import { API_CONFIG } from "../config/api";

export class AuditService {
  static BASE_URL = API_CONFIG.BASE_URL;

  // Generic request handler
  static async makeRequest(url, options, getAccessTokenSilently) {
    try {
      const token = await getAccessTokenSilently();
      const response = await fetch(`${this.BASE_URL}${url}`, {
        ...options,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          ...options.headers,
        },
      });

      if (!response.ok) {
        const errorData = await response.text();
        let errorMessage;
        try {
          const parsedError = JSON.parse(errorData);
          errorMessage =
            parsedError.error || parsedError.message || "Request failed";
        } catch {
          errorMessage =
            errorData || `HTTP ${response.status}: ${response.statusText}`;
        }
        throw new Error(errorMessage);
      }

      return await response.json();
    } catch (error) {
      throw error;
    }
  }

  // Get audit history for a specific entity (risk, control, or user)
  static async getEntityAuditHistory(
    entityType,
    entityId,
    organizationId,
    params = {},
    getAccessTokenSilently
  ) {
    const queryParams = new URLSearchParams({
      organization_id: organizationId,
      ...params,
    });

    return this.makeRequest(
      `/audit/${entityType}/${entityId}?${queryParams.toString()}`,
      { method: "GET" },
      getAccessTokenSilently
    );
  }

  // Get organization audit history
  static async getOrganizationAuditHistory(
    organizationId,
    params = {},
    getAccessTokenSilently
  ) {
    const queryParams = new URLSearchParams(params);

    return this.makeRequest(
      `/audit/organization/${organizationId}?${queryParams.toString()}`,
      { method: "GET" },
      getAccessTokenSilently
    );
  }

  // Get business unit audit history
  static async getBusinessUnitAuditHistory(
    businessUnitId,
    params = {},
    getAccessTokenSilently
  ) {
    const queryParams = new URLSearchParams(params);

    return this.makeRequest(
      `/audit/business-unit/${businessUnitId}?${queryParams.toString()}`,
      { method: "GET" },
      getAccessTokenSilently
    );
  }

  // Get organization audit statistics
  static async getOrganizationAuditStats(
    organizationId,
    params = {},
    getAccessTokenSilently
  ) {
    const queryParams = new URLSearchParams(params);

    return this.makeRequest(
      `/audit/stats/organization/${organizationId}?${queryParams.toString()}`,
      { method: "GET" },
      getAccessTokenSilently
    );
  }
}
